import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import MuiAccordion from "@material-ui/core/Accordion"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Link, useLocation, useHistory } from "react-router-dom"
import MuiAccordionSummary from "@material-ui/core/AccordionSummary"
import MuiAccordionDetails from "@material-ui/core/AccordionDetails"
import Typography from "@material-ui/core/Typography"
import AddIcon from "@material-ui/icons/Add"
import { Box, Tooltip } from "@material-ui/core"
import { checkToShowNativeFormat, getSourceSvg, SOURCE_TYPE } from "../../utils"
import { Skeleton } from "@material-ui/lab"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Divider from "@material-ui/core/Divider"
import MinimizeIcon from "@material-ui/icons/Minimize"
import InboxIcon from "@material-ui/icons/Inbox"
import DraftsIcon from "@material-ui/icons/Drafts"
import {
	getFileRowClickRequest,
	getFileRequestByPage,
	getPageNumberBasedOnFileIdRequest,
	resetPageViewerData,
	getPageNumberBasedOnHighlightTextRequest,
} from "../../actions/documentModalActions"
import { getComments } from "../../actions/documentsActions"
import { getConceptBasedOnId, searchHighlightFilter } from "../../actions/highlightActions"
import { getAnnotation, getAuditHistory, getChat, updateCurrentSession, updateViewerPageNumber } from "../../actions/viewerActions"
import { useTranslation } from "react-i18next"
import { getReviewBasedOnFileIdRequest } from "../../actions/reviewActions"
import { getInfo } from "../../actions/infoActions"

const Accordion = withStyles((theme) => ({
	root: {
		...theme.typography.body2,
		backgroundColor: theme.palette.common.white,
		borderTop: `solid 1px ${theme.palette.grey.D400}`,
		borderBottom: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		"&:not(:last-child)": {
			borderBottom: 0,
		},
		"&:before": {
			display: "none",
		},
		"&$expanded": {
			margin: "auto",
		},
		"& .MuiIconButton-root": {
			color: theme.palette.grey.D300,
		},
		"& .Mui-expanded": {
			backgroundColor: theme.palette.grey.D1300,
		},
		"& .MuiAccordionDetails-root": {
			padding: 0,
			"& .MuiList-root": {
				width: "100%",
			},
		},
	},
	pageNumber: {
		width: "100%",
		maxWidth: 360,
		backgroundColor: theme.palette.background.paper,
	},
	expanded: {},
}))(MuiAccordion)

const useStyles = makeStyles((theme) => ({
	fileNameWrapper: {
		cursor: "pointer",
		"&:hover": {
			textDecoration: "underline",
		},
	},
}))

const AccordionSummary = withStyles((theme) => ({
	root: {
		...theme.typography.body2,
		backgroundColor: theme.palette.common.white,
		border: "none",
		marginBottom: -1,
		minHeight: 56,
		"&$expanded": {
			minHeight: 56,
		},
	},
	content: {
		"&$expanded": {
			margin: "12px 0",
		},
	},
	expanded: {},
}))(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiAccordionDetails)

const ViewerDocumentListAccordion = ({ retainedFilterJobData }) => {
	const [expanded, setExpanded] = useState("panel1")
	const classes = useStyles()
	const theme = useTheme()
	const location = useLocation()
	const [t] = useTranslation("global")
	const { allDocuments, allDocumentsCount, allDocumentsLoading } = useSelector((state) => state.viewerData)
	const aiEnabled = useSelector((state) => state?.info?.version?.ai_enabled)
	const { review } = useSelector((state) => state.review)
	const {
		documentDetails,
		pageNumberForCurrentDocument,
		pageNumberBasedOnHighlightedText,
		documentLoading,
		ispageNumberBasedOnHighlightedTextLoading,
	} = useSelector((state) => state.documentModal)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const [searchDocumentsList, setSearchDocumentslist] = useState({ count: 0, data: [] })
	const [pageNumberCount, setPageNumberCount] = useState([])
	const [selectedIndex, setSelectedIndex] = React.useState(1)
	const [docsToSHow, setDocsToSHow] = useState({ count: 0, data: [] })
	const { currentPageNumber, skipCount } = useSelector((state) => state.viewerData)
	const { id } = useSelector((state) => state?.review?.review)
	const dispatch = useDispatch()
	const [currentpage, setCurrentPage] = useState(1)
	const [totalpages, setTotalPages] = useState(1)

	const handleChange = (item) => (event, newExpanded) => {
		const panel = item?.file_id
		if (!newExpanded) {
			setExpanded(newExpanded ? panel : false)
			return false
		}
		if (!["img", "audio", "video"].includes(item?.metadata?.source)) {
			setExpanded(newExpanded ? panel : false)
		}
		dispatch(resetPageViewerData())
		if (id) {
			dispatch(getFileRowClickRequest({ id: panel, reviewId: id }))
		} else if (retainedFilterJobData?.additional_params?.search_id) {
			dispatch(getFileRowClickRequest({ id: panel, searchId: retainedFilterJobData?.additional_params?.search_id }))
		} else {
			dispatch(getFileRowClickRequest(panel))
		}
		dispatch(getFileRequestByPage({ id: panel, page: 1, reviewId: retainedFilterJobData?.additional_params?.review_id }))
		const params = location?.pathname?.split("/")
		if (retainedFilterJobData) {
			const payload = {
				categories: retainedFilterJobData?.categories || [],
				text: retainedFilterJobData?.text
					? [...retainedFilterJobData?.text, ...highlightFilter?.searchWord, ...highlightFilter?.loadedConcept]
					: [],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [panel],
			}
			//dispatch(getPageNumberBasedOnFileIdRequest(payload))
			dispatch(updateViewerPageNumber(1))
			dispatch(getAuditHistory(panel))
			dispatch(getAnnotation(panel, checkToShowNativeFormat(documentDetails?.metadata)))
			dispatch(getReviewBasedOnFileIdRequest(panel))
			const chatPayload = {
				file_ids: [panel],
			}
			if (aiEnabled) {
				dispatch(getChat(chatPayload))
			}
			dispatch(updateCurrentSession(0))
			// Commenting this for now as we dont need to show the page number hit on page load now.
			// if (!_.isEmpty(retainedFilterJobData?.categories)) {
			// 	dispatch(getConceptBasedOnId(retainedFilterJobData?.categories))
			// }
			// if (!_.isEmpty(retainedFilterJobData?.text)) {
			// 	const filterData = { ...highlightFilter }
			// 	filterData.loadedConcept = [...filterData?.loadedConcept, ...retainedFilterJobData?.text]
			// 	dispatch(searchHighlightFilter(filterData))
			// }
			getPageNumberBasedOnHighlightText(panel)
			const filterData = { ...highlightFilter }
			filterData["nativeView"] = !filterData["nativeView"]
			dispatch(searchHighlightFilter(filterData))
		}
	}

	useEffect(() => {
		if (!_.isEmpty(allDocuments)) {
			setDocsToSHow({
				count: allDocumentsCount,
				data: allDocuments,
			})
		}
	}, [allDocuments])

	useEffect(() => {
		if (searchDocumentsList.count > 0) {
			let auxToShow = {
				count: searchDocumentsList.count,
				data: searchDocumentsList.data,
			}
			auxToShow = {
				count: auxToShow.count,
				data: auxToShow.data.slice(20 * (currentpage - 1), 21 * currentpage - currentpage),
			}
			setDocsToSHow({
				count: auxToShow.count,
				data: auxToShow.data,
			})
		} else {
			setDocsToSHow({
				count: 0,
				data: [],
			})
		}
	}, [searchDocumentsList, currentpage])

	const getPageNumberBasedOnHighlightText = (fileId) => {
		const params = location?.pathname?.split("/")
		if (highlightFilter["specificWord"] || highlightFilter["concepts"]) {
			let searchText = highlightFilter["specificWord"] ? highlightFilter?.searchWord : []
			let selectedConcept = highlightFilter["concepts"] ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}
			dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
		}
	}
	useEffect(() => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		//setExpanded(fileId)
		setTimeout(() => {
			document.getElementById(fileId.toString())?.scrollIntoView(true)
		}, 5000)
	}, [])

	const handleListItemClick = (event, page, fileId) => {
		const reviewId = retainedFilterJobData?.additional_params?.review_id
		setSelectedIndex(page)
		dispatch(updateViewerPageNumber(page))
		dispatch(getFileRequestByPage({ id: fileId, page: page, reviewId }))
		const viewerContainer = document.getElementById("viewer-container")
		viewerContainer?.scrollIntoView(true)
	}

	useEffect(() => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		if (_.isEmpty(documentDetails?.comments)) {
			dispatch(getComments(fileId))
		}
	}, [documentDetails?.file_id, documentDetails?.comments])

	useEffect(() => {
		setPageNumberCount(pageNumberBasedOnHighlightedText)
	}, [pageNumberBasedOnHighlightedText])

	// useEffect(() => {
	// 	if (!_.isEmpty(review)) {
	// 		const reviewFileId = location?.pathname?.split("/")?.[4]
	// 		setSelectedReview(review?.id)
	// 		setReviewGoal(review?.objective)
	// 		const markReview = review?.file_ids?.[reviewFileId]?.reviewed
	// 		setIsMarkReviewApplicable(markReview)
	// 		setMarkReviewStatus(markReview || false)
	// 	}
	// }, [review])

	const fileNameSection = (params) => {
		return (
			<Tooltip title={params?.metadata?.title || params?.name} placement="top">
				<Box
					className={classes.fileNameWrapper}
					style={{ display: "flex", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", textDecoration: "none" }}
				>
					<Box style={{ marginRight: "16px" }}>{getSourceSvg(params?.metadata?.source, params?.children_files)}</Box>
					<Box style={{ display: "flex", alignItems: "center" }}>
						<Typography
							noWrap
							style={{
								...theme.typography.body2,
								textDecoration: "none",
								width: "240px",
								color: review?.file_ids?.[params?.file_id]?.reviewed ? theme.palette.text.reviewed : "",
							}}
						>
							{params?.metadata?.title || params?.name}
						</Typography>
					</Box>
				</Box>
			</Tooltip>
		)
	}

	return (
		<Box id="document-list-container">
			{docsToSHow?.count !== 0 && !allDocumentsLoading ? (
				<>
					{docsToSHow?.data?.map((item) => {
						const params = location?.pathname?.split("/")
						const fileId = params[params.length - 1]
						return (
							<Accordion id={item?.file_id} square expanded={expanded === item?.file_id} onChange={handleChange(item)}>
								<AccordionSummary
									aria-controls="panel1d-content"
									id="panel1d-header"
									className={fileId === item?.file_id ? "Mui-expanded" : ""}
									expandIcon={
										["img", "audio", "video"].includes(item?.metadata?.source) ? (
											<></>
										) : expanded === item?.file_id ? (
											<MinimizeIcon />
										) : (
											<AddIcon />
										)
									}
									component={Link}
									to={{
										pathname: item?.file_id,
										search: window?.location?.search,
										state: { prevPath: location?.state?.prevPath },
									}}
								>
									<Typography>{fileNameSection(item)}</Typography>
								</AccordionSummary>
								<AccordionDetails
									style={{
										maxHeight: "25vh",
										overflowY: "auto",
									}}
								>
									<List className={classes.pageNumber} component="nav" aria-label="main mailbox folders">
										{!ispageNumberBasedOnHighlightedTextLoading ? (
											!_.isEmpty(pageNumberCount) ? (
												pageNumberCount?.map((page) => {
													return (
														<>
															<ListItem
																button
																selected={currentPageNumber === page}
																onClick={(event) => handleListItemClick(event, page, item?.file_id)}
															>
																<ListItemText style={{ paddingLeft: "60px" }}>{`${t(
																	"viewer.page"
																)} ${page}`}</ListItemText>
															</ListItem>
															<Divider style={{ border: `solid 1px ${theme.palette.grey.D400}` }} />
														</>
													)
												})
											) : (
												<List className={classes.pageNumber} component="nav" aria-label="main mailbox folders">
													<ListItemText style={{ paddingLeft: "60px" }}>{"No result found"}</ListItemText>
												</List>
											)
										) : (
											<>
												<Skeleton
													animation="wave"
													variant="rectangular"
													height="6vh"
													style={{ margin: "5px 10px" }}
												/>
												<Skeleton
													animation="wave"
													variant="rectangular"
													height="6vh"
													style={{ margin: "5px 10px" }}
												/>
											</>
										)}
									</List>
								</AccordionDetails>
							</Accordion>
						)
					})}
				</>
			) : (
				<Box style={{ padding: "16px 23px" }}>
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
					<Skeleton animation="wave" variant="rectangular" height="5vh" style={{ margin: "5px" }} />
				</Box>
			)}
		</Box>
	)
}

export default ViewerDocumentListAccordion
